export default __webpack_public_path__ + "static/media/2633 (1) (1).015cb6fe.jpg";